import {parse, stringify} from 'flatted';
import UIAvatarSvg from './letter-avatar.js';
import _ from 'lodash';

function logoUrl(website, size, failed) {
  var url = "https://logo.accountingbox.nl?website=" + website;
  return url;
}

function logoUrlName(name, size, failed) {
  var url = "https://logo.accountingbox.nl?name=" + name;
  return url;
}
//
// angular.module("AccountingBoxApp").component("logo", {
//   template: "<img ng-src='$ctrl.logoUrl'/> ",
//   controller: companyAutocompleteController,
//   bindings: {
//     company: "=",
//     onCompanySelect: "&",
//     onUpdate: "&"
//   }
// });

angular.module("AccountingBoxApp").directive("abLogo", function($timeout) {
  return {
    // restrict: 'E',
    scope: {
      organisation: "<",
      bgColor: "@",
      textColor: "@",
    },
    link: function(scope, element, attrs) {
      var failed = false;
      function organisationChanged() {
        var organisation = scope.organisation;
        if (!organisation) {
          return element.hide();
        }

        if (organisation.initials ) {
          return setUnknownLogo(organisation, element);
        }

          if (!organisation.website && !organisation.name && !organisation?.invoiceSettings?.logoUrl) {
          setUnknownLogo(organisation, element);
        } else {
          let url;
          if(organisation?.logoUrl) {
            url = organisation?.logoUrl
          } else if(organisation.website) {
            url = logoUrl(organisation.website)
          }else {
            url = logoUrlName(organisation.name)
          }
          failed = false;
          element.attr("src", url);
          element.show();
        }
      }

      scope.$watch(
        function() {
          if (!scope.organisation) return;
          return JSON.stringify({
            website: scope.organisation.website,
            name: scope.organisation.name,
            type: scope.organisation.type
          });
        },
        function(newValue) {
          organisationChanged();
        }
      );
      let attempts = 0
      element.bind("error", function(e) {
        // console.log('e',e);
        if(attempts < 4) {
          attempts++
          setUnknownLogo(scope.organisation, element);
        }
      });
      function getInitials(name) {
        return name?.split(' ').length > 1 ? name?.split(' ').slice(0,2).map(w => w.charAt(0).toUpperCase()).join(''): name?.slice(0,2).toUpperCase()
      }

      function setUnknownLogo(organisation, element) {
        organisation = parse(stringify(organisation));
        const avatar = new UIAvatarSvg();
        const svg = avatar.generate();
        avatar.text(getInitials(_.deburr(organisation.initials || organisation.name)));
        avatar.bgColor(scope.bgColor || "#ecedf0");
        avatar.textColor(scope.textColor || "var(--ds-text-highEmphasis,#172B4D)")
        avatar.fontWeight(500);
        element.attr("src",  "data:image/svg+xml;base64," + btoa(avatar.generate()));
        element.show();
      }
    }
  };


});
